









import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import {formatDate, formatDateTime} from "@/utils/formatters";

@Component({})
export default class ObjektiCard2TabPosete extends Vue {
  @Prop() store!: {};
  @Prop() visits!: [];
  @Prop({default: false}) isBusyLoadingVisits!: boolean;

  columns = [];
  options = {
    pagination: true,
    pageSize: 25,
    onClickRow: row => this.onClickRow(row)
  };

  created() {
    this.columns = [
      {field: 'date', title: this.$i18n.t('datum'), formatter: value => formatDate(value)},
      {field: 'user', title: this.$i18n.t('merchandiser')}
    ];
  }

  @Watch('isBusyLoadingVisits') isBusyChange(value) {
    let table = $('#visitsTable');
    if (value) {
      table.bootstrapTable('showLoading');
    } else {
      table.bootstrapTable('hideLoading');
    }
  }

  onClickRow(row) {
    this.$router.push({name: 'poseta', params: {publicVisitID: row.publicId}})
  }
}
